import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=6d0086bb"
import script from "./DataLoader.vue?vue&type=script&lang=js"
export * from "./DataLoader.vue?vue&type=script&lang=js"
import style0 from "./DataLoader.vue?vue&type=style&index=0&id=6d0086bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinner,QColor});
